export default "__VITE_ASSET__D0hWn3w___";